import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { CancelableRequestProducer } from 'api/common/types'

export class ApiInstance {
  client: AxiosInstance

  constructor(config?: AxiosRequestConfig) {
    this.client = axios.create(config)
  }

  get<T extends unknown = unknown>(url: string, config?: AxiosRequestConfig): CancelableRequestProducer<T> {
    return signal => this.client.get(url, { ...config, signal })
  }

  post<T extends unknown = unknown>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): CancelableRequestProducer<T> {
    return signal => this.client.post(url, data, { ...config, signal })
  }

  put<T extends unknown = unknown>(url: string, data?: any, config?: AxiosRequestConfig): CancelableRequestProducer<T> {
    return signal => this.client.put(url, data, { ...config, signal })
  }

  patch<T extends unknown = unknown>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): CancelableRequestProducer<T> {
    return signal => this.client.patch(url, data, { ...config, signal })
  }

  delete<T extends unknown = unknown>(url: string, config?: AxiosRequestConfig): CancelableRequestProducer<T> {
    return signal => this.client.delete(url, { ...config, signal })
  }
}

export const createApi = (config?: AxiosRequestConfig) => new ApiInstance(config)
